//import { useMediaQuery } from "react-responsive";

function deviceConfig() {}

export default deviceConfig;
